import React, { Component } from 'react';
import { Button, Col, Alert } from 'antd';
import PropTypes from 'prop-types';
import { getLivePriceRequest } from '../../requests/getLivePriceRequest';

export class UpdateValuationBtn extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            message: null,
        };
    }

    getLivePrice = async () => {
        try {
            this.setState({ isLoading: true, message: null });
            const response = await getLivePriceRequest(this.props.leadId);

            if (response.result && !response.error) {
                const { price: valuation, retailPrice, error } = response.options;

                if (!error) {
                    this.props.onSuccess({ valuation, retailPrice });
                } else {
                    this.setState({ message: `No Live Price Available – contact pricing team. Reason: ${error}` });
                    this.props.onNoPrice();
                }
            } else {
                this.props.onFailure(`Failed to get valuation: ${response.error}`);
            }
        } catch (err) {
            this.props.onFailure(`Failed to get valuation: ${err.error?.message}`);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    render() {
        const { message, isLoading } = this.state;

        return (
            <Col span={24}>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        type="primary"
                        style={{ backgroundColor: '#52c41a' }}
                        loading={isLoading}
                        onClick={this.getLivePrice}
                    >
                        Update Valuation
                    </Button>
                </div>
                {message
                    && (
                        <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '8px 0 16px' }}>
                            <Alert message={message} type="warning" />
                        </div>
                    )
                }
            </Col>
        );
    }
}

UpdateValuationBtn.propTypes = {
    leadId: PropTypes.string.isRequired,
    onSuccess: PropTypes.func.isRequired,
    onNoPrice: PropTypes.func.isRequired,
    onFailure: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Modals/BikeValuationUpdateBtn.js